<script>
import baseList from "@/views/components/base/baseList.vue";
import { Poptip, Button } from "view-design";
import Clipboard from "clipboard";
import SysLogList from "../../log/uplog/list.vue";
let customerId = window.localStorage.getItem("customerId");
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "user",
        key: "id",
        url: {
          list: "/admin/system/user/lista",
          del: "/admin/system/user",
        },
        output: false,
      },
      menus: [],
      actions: [
        {
          label: "新增",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "admin/authaccess/add",
        },
      ],
      tactions: [
        // { label: '导出数据', type: 'success', onClick: this.exportData.bind(this, '账户数据', 0), auth: '/admin/authaccess/lists' },
        // { label: '导出全部数据', type: 'error', onClick: this.exportData.bind(this, '账户数据', 1), auth: '/admin/authaccess/lists' },
      ],
      query: {},
      filters: [
        { label: "手机号", name: "phonenumber", value: "", type: "input" },
        { label: "姓名", name: "nickName", value: "", type: "input" },
        { label: "账号", name: "userName", value: "", type: "input" },
      ],
      tableCols: [
        // {
        //   type: 'selection',
        //   minWidth: 60,
        // },
        // {
        //   title: "序号",
        //   type: "index",
        //   minWidth: 80,
        //   align: "center",
        // },
        {
          title: "账号",
          key: "",
          tree: true, //树形
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            let text = row.userName;
            return h("span", {}, text);
          },
        },
        {
          title: "姓名",
          key: "",
          minWidth: 120,
          render: (h, params) => {
            const row = params.row;
            let text = row.nickName;
            return h("span", {}, text);
          },
        },
        {
          title: "手机号",
          key: "",
          minWidth: 140,
          render: (h, params) => {
            const row = params.row;
            let text = row.phonenumber;
            return h("span", {}, text);
          },
        },
        {
          title: "员工类型",
          key: "mainType",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.mainType == 1 && row.makeMain == "2"
                ? "维修员"
                : row.makeMain == "1"
                ? "管理员"
                : row.makeMain == "3"
                ? "管理/维修"
                : row.makeMain == "1" && row.isAdmin == 1
                ? "超级管理员"
                : row.makeMain == "3" && row.isAdmin == 1
                ? "超级管理/维修"
                : row.mainType == 2 && row.makeMain == "2"
                ? "派单员"
                : "用户";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "工单类型",
          key: "typeName",
          minWidth: 120,
          align: "center",
          tooltip: "true",
        },
        {
          title: "工作时间",
          key: "mainStartTime",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.mainStartTime != null
                ? row.mainStartTime + "-" + row.mainEndTime
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "综合评分",
          key: "count",
          minWidth: 140,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            let dom = null;
            dom =
              row.count != null
                ? h("div", [
                    // 插入评分
                    h("Rate", {
                      style: {
                        display: "block",
                        color: "gray",
                      },
                      props: {
                        count: 5,
                        disabled: true,
                        value: params.row.count,
                      },
                    }),
                  ])
                : "";
            return dom;
          },
        },
        {
          title: "头像",
          key: "",
          minWidth: 80,
          render: (h, params) => {
            const row = params.row;
            let src = $utils.image.load(row.avatar);
            return h("Avatar", {
              props: {
                src: src,
              },
            });
          },
        },
        // {
        //   title: "性别",
        //   key: "sex",
        //   minWidth: 80,
        //   align: "center",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const color = row.sex == 1 ? "blue" : row.sex == 2 ? "red" : "";
        //     const text = row.sex == 1 ? "男" : row.sex == 2 ? "女" : "";
        //     return h(
        //       "span",
        //       {
        //         style: {
        //           "font-size": "14px",
        //           color: color,
        //         },
        //       },
        //       text
        //     );
        //   },
        // },
        // {
        //   title: "状态",
        //   align: "center",
        //   key: "status",
        //   minWidth: 80,
        //   render: (h, params) => {
        //     const row = params.row;
        //     const color =
        //       row.status == 0 ? "blue" : row.status == 1 ? "red" : "";
        //     const text =
        //       row.status == 0 ? "正常" : row.status == 1 ? "停用" : "";
        //     return h(
        //       "span",
        //       {
        //         style: {
        //           "font-size": "14px",
        //           color: color,
        //         },
        //       },
        //       text
        //     );
        //   },
        // },
        // {
        //   title: "备注",
        //   key: "remark",
        //   minWidth: 170,
        //   align: "center",
        // },
        // {
        //   title: '更新时间',
        //   key: 'updateTime',
        //   minWidth: 170,
        // },
        // {
        //   title: "创建时间",
        //   width: 115,
        //   align: "center",
        //   key: "createTime",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const text = row.createTime.slice(0, 16);
        //     return <span>{text}</span>;
        //   },
        // },
        // {
        //   title: "登录账号",
        //   minWidth: 120,
        //   align: "center",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const text = row.userName;
        //     const copyId = "table_cp_user";
        //     return (
        //       <div
        //         style={{
        //           margin: "2px 0",
        //           "font-size": "13px",
        //           "text-align": "center",
        //         }}
        //       >
        //         <div
        //           style={{ cursor: "pointer", margin: "0", color: "#19be6b" }}
        //           data-clipboard-text={text}
        //           class={copyId}
        //           onClick={() => {
        //             let clipboard = new Clipboard("." + copyId);
        //             this.$Message.info("已复制 " + text);
        //           }}
        //         >
        //           {text}
        //         </div>
        //       </div>
        //     );
        //   },
        // },
        // {
        //   title: '登录密码',
        //   minWidth: 120,
        //   align: 'center',
        //   render: (h, params) => {
        //     const row = params.row
        //     const text = `${row.opassword || ''}`
        //     const copyId = 'table_cp_pw'
        //     return (
        //       <div style={{ margin: '2px 0', 'font-size': '13px', 'text-align': 'center' }}>
        //         <div
        //           style={{ cursor: 'pointer', margin: '0', color: '#f20' }}
        //           data-clipboard-text={text}
        //           class={copyId}
        //           onClick={() => {
        //             let clipboard = new Clipboard('.' + copyId)
        //             this.$Message.info('已复制 ' + text)
        //           }}
        //         >
        //           {text}
        //         </div>
        //       </div>
        //     )
        //   },
        // },
        {
          title: "操作",
          align: "center",
          minWidth: 160,
          key: "handle",
          fixed: "right",
          handle: [
            // (vm, h, currentRow, param) => {
            //   return (
            //     <Button type="success" size="small" onClick={this.logRecord.bind(this, currentRow)} style={{ margin: '4px 5px' }}>
            //       操作日志
            //     </Button>
            //   )
            // },
            "edit",
            (vm, h, currentRow, param) => {
              let row = param.row;
              return (
                <Button
                  size="small"
                  onClick={() => {
                    this.updateAuth(currentRow);
                  }}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    display: row.makeMain == null ? "" : "none",
                    marginLeft: "5px",
                  }}
                >
                  {currentRow?.perms == 1 ? "禁用盘点" : "启用盘点"}
                </Button>
              );
            },
            "delete",
          ],
          auth: {
            edit: "admin/authaccess/edit",
            del: "admin/authaccess/delete",
          },
        },
      ],
    };
  },
  async created() {
    // await this.loadFiltersFieldDrop('auth_type', 'type')
  },
  methods: {
    updateAuth(currentRow) {
      $utils.api
        .load(
          `/admin/system/cusUser/${
            currentRow?.perms == 1 ? "disablePermsById" : "enablePermsById"
          }?userId=${currentRow.id}`,
          {},
          "POST"
        )
        .then((res) => {
          if (res?.code === 200) {
            this.search();
          }
        });
    },
    toAdd() {
      $utils.url.push({ name: "auth_access_add", query: { action: "add" } });
    },
    handleEdit(row) {
      console.log(555, row);
      $utils.url.push({
        name: "auth_access_edit",
        query: { action: "edit", kv: row.id },
      });
    },
    handleDel(row) {},
    logRecord(row) {
      this.$Modal.info({
        title: "操作日志",
        width: "900px",
        showOk: false,
        render: (h) => {
          return (
            <SysLogList
              style={{ margin: "0", color: "#19be6b" }}
              table_name={"auth_access"}
              table_key={row.suid}
            ></SysLogList>
          );
        },
      });
    },
  },
};
</script>
